<template>
  <div class="container shop">
    <follow @follow="followFn"></follow>
    <div class="header" :style="follow ? { top: '0.5rem' } : { top: '0' }">
      <div class="tit">创客云商发货</div>
      <div
        :class="{ edit: true, active: goodsDelShow }"
        v-if="list && list.length > 0"
        @click="changeEdit"
      >
        {{ goodsDelShow ? '完成' : '编辑' }}
      </div>
      <div class="kefu" @click="keFu">
        <img src="../../assets/images/service.png" />
      </div>
    </div>
    <div id="cup" :style="follow ? { 'margin-top': '0.95rem' } : { 'margin-top': '0.44rem' }">
      <Scroller
        v-if="!nodata"
        :is-refresh-data.sync="refresh"
        :is-loading-data.sync="loading"
        :is-finished-data.sync="finished"
        :no-data-text-data.sync="noDataText"
        @on-infinite="onInfinite"
        @on-refresh="onRefresh"
        class="my_scroller"
        ref="my_scroller"
      >
        <div class="skinTest" style="margin-top: 0.05rem;margin-bottom: 0.1rem;" v-if="advertis">
          <advertisingSpace></advertisingSpace>
        </div>
        <act-coupon></act-coupon>
        <div
          class="couponmsg flex-js-ac"
          v-if="topmsg && (topmsg.type == 2 || topmsg.type == 3)"
          style="width: 100%;"
          @click="$router.push('/cashcoupon' + (topmsg.type == 3 ? '?navIndex=1' : ''))"
        >
          <div class="flex-ac">
            <div class="couponImg">
              <img
                class="flex-1"
                :src="topmsg.type == 3 ? topmsg.img_path : '/static/images/coupon@2x.png'"
              />
              <span v-if="topmsg.type == 2" class="f13 color-FC0324">{{ topmsg.couponmoney }}</span>
            </div>
            <div>
              <p class="f13" style="color: #333333;font-weight: bold;margin-bottom: 0.03rem">
                {{ topmsg.message1 }}
              </p>
              <p class="f12" style="color: #6C6C6C;">{{ topmsg.message2 }}</p>
            </div>
          </div>
          <div class="f13 flex-ac color-FC0324">
            卡券包
            <van-icon name="arrow" color="#FC0324" />
          </div>
        </div>
        <div class="cart_list" v-if="list && list.length > 0">
          <van-sticky :offset-top="0" @change="fixedFn">
            <div
              class="additemMsg fullsubtract"
              :style="fixedStyle"
              v-if="fullMinusRules.actStatus != -1"
              @click="gofullsubtract"
            >
              <div class="msg">
                <div
                  class="txt flex"
                  v-if="fullMinusRules.actStatus == 0 && fullMinusRules.actDesc"
                >
                  <van-tag
                    class="flex-s"
                    color="linear-gradient(to right, #FE074A, #F63A66)"
                    text-color="#ffffff"
                  >
                    {{ fullMinusRules.actName }}
                  </van-tag>
                  <b>{{ fullMinusRules.actDesc }}</b>
                </div>
                <div class="txt flex" v-else>
                  <van-tag
                    class="flex-s"
                    color="linear-gradient(to right, #FE074A, #F63A66)"
                    text-color="#ffffff"
                  >
                    {{ fullMinusRules.actName }}
                  </van-tag>
                  <b v-html="fullMinusMsg"></b>
                </div>
              </div>
              <div class="btn" v-if="fullMinusRules.actStatus != -1">凑单></div>
            </div>
          </van-sticky>
          <div
            :class="{ cart_item: true, soldoutx: item.inventory == 0 || item.is_can_buy == 0 }"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="product_list">
              <div v-if="item.isdeposit == 1">
                <van-checkbox
                  :disabled="
                    item.finalpaystatus == 0 ||
                      (item.inventory == 0 ||
                        item.islimit != 0 ||
                        item.is_can_buy == 0 ||
                        parseInt(item.canbuycnt) <= 0)
                  "
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                  checked-color="#FC0324"
                  v-if="!goodsDelShow"
                  v-model="item.ischoose"
                ></van-checkbox>
                <van-checkbox
                  :disabled="item.isdeposit == 1"
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                  checked-color="#FC0324"
                  v-if="goodsDelShow"
                  v-model="item.ischoose"
                ></van-checkbox>
              </div>
              <div v-else>
                <van-checkbox
                  v-if="!goodsDelShow"
                  v-model="item.ischoose"
                  checked-color="#FC0324"
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                  :disabled="
                    item.inventory == 0 ||
                      item.islimit != 0 ||
                      item.is_can_buy == 0 ||
                      (parseInt(item.canbuycnt) <= 0 || item.issale == 0)
                  "
                ></van-checkbox>
                <van-checkbox
                  v-if="goodsDelShow"
                  v-model="item.ischoose"
                  checked-color="#FC0324"
                  @change="checkedSingle(item)"
                  @click="checkedSingleFn(item)"
                ></van-checkbox>
              </div>
              <div class="proitem">
                <div class="proimgx">
                  <img v-lazy="item.img_path" class="proimg" @click="productFn(item)" />
                  <img
                    src="../../assets/images/soldout.png"
                    @click="productFn(item)"
                    class="soldout"
                    v-if="item.inventory == 0 && item.issale == 0 && item.is_can_buy != 0"
                  />
                  <img
                    src="../../assets/images/daishou.png"
                    @click="productFn(item)"
                    class="soldout"
                    v-if="
                      item.isdeposit == 0 &&
                        item.inventory == 1 &&
                        item.islimit == 1 &&
                        item.canbuycnt > 0 &&
                        item.issale == 1 &&
                        item.is_can_buy != 0
                    "
                  />
                  <img
                    @click="productFn(item)"
                    class="soldout"
                    src="../../assets/images/daishou.png"
                    v-if="
                      item.isdeposit == 1 &&
                        item.inventory == 1 &&
                        item.islimit == 1 &&
                        item.canbuycnt > 0 &&
                        item.is_can_buy != 0
                    "
                  />
                  <img
                    @click="productFn(item)"
                    class="soldout"
                    src="/static/images/shouqing.png"
                    v-if="
                      item.inventory == 0 &&
                        item.islimit == 2 &&
                        item.canbuycnt > 0 &&
                        item.is_can_buy != 0
                    "
                  />
                </div>
                <div class="goods_info">
                  <div @click="productFn(item)" class="goods_tit flex">
                    <div>
                      <label v-if="item.name.length < 26">{{ item.name }}</label>
                      <label v-if="item.name.length >= 26">{{ item.name.slice(0, 26) }}...</label>
                      <img src="../../assets/images/overseas.png" v-if="item.isoversea == 1" />
                    </div>
                    <label v-if="item.isdeposit == 1">x{{ item.num }}</label>
                  </div>
                  <!--style="margin-bottom: 0.07rem"-->
                  <div class="goods_spec" v-if="item.isdeposit == 1">
                    <div class="dspec" style="background: transparent;">{{ item.spec }}</div>
                  </div>
                  <div class="goods_spec" v-else>
                    <div
                      class="dspec again"
                      v-if="item.inventory == 1 && (item.islimit == 2 || item.issale == 0)"
                      @click="openSku(item, index)"
                    >
                      重选
                      <van-icon name="arrow-down" color="#FE5E00" />
                    </div>
                    <div class="dspec" v-else @click="openSku(item, index)">
                      {{ item.spec }}
                      <van-icon name="arrow-down" />
                    </div>
                  </div>
                  <div
                    style="font-size:0.11rem;
                            font-weight:400;
                            color:rgba(254,94,0,1);
                            line-height:0.16rem;
                            padding: 0.05rem 0;
                "
                    v-if="
                      parseInt(item.canbuycnt) <= parseInt(item.lib_warning) &&
                        parseInt(item.canbuycnt) > 0 &&
                        item.islimit == 0 &&
                        item.issale == 1
                    "
                  >
                    <p>库存紧张</p>
                  </div>
                  <div class="PriceAndNum">
                    <div class="goods_price">
                      <span
                        class="smallprice"
                        v-if="
                          (!item.fullDiscountPrice &&
                            item.isdeposit == 0 &&
                            !item.isDirectReduction &&
                            item.isDirectReduction == 0 &&
                            (item.canbuycnt > 0 && item.islimit != 2 && item.issale == 1)) ||
                            item.inventory == 0
                        "
                        style="font-size: 0;"
                      >
                        <sub>¥</sub>
                        <b>
                          {{
                            String(parseFloat(item.sales_price).toFixed(2)).slice(
                              0,
                              String(parseFloat(item.sales_price).toFixed(2)).indexOf('.')
                            )
                          }}
                        </b>
                        <sup>
                          {{
                            String(parseFloat(item.sales_price).toFixed(2)).slice(
                              String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'),
                              String(parseFloat(item.sales_price).toFixed(2)).length
                            )
                          }}
                        </sup>
                      </span>
                      <span
                        class="smallprice"
                        v-else-if="item.isdeposit == 1"
                        style="font-size: 0;"
                      >
                        <sub>尾款¥</sub>
                        <b>
                          {{
                            String(parseFloat(item.sales_price).toFixed(2)).slice(
                              0,
                              String(parseFloat(item.sales_price).toFixed(2)).indexOf('.')
                            )
                          }}
                        </b>
                        <sup>
                          {{
                            String(parseFloat(item.sales_price).toFixed(2)).slice(
                              String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'),
                              String(parseFloat(item.sales_price).toFixed(2)).length
                            )
                          }}
                        </sup>
                      </span>
                      <div v-else-if="item.isDirectReduction && item.isDirectReduction == 1">
                        <span class="smallprice grayPrice">
                          <sub>¥</sub>
                          <b>
                            {{
                              String(
                                (
                                  parseFloat(item.sales_price) +
                                  parseFloat(item.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  (
                                    parseFloat(item.sales_price) +
                                    parseFloat(item.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.')
                              )
                            }}
                          </b>
                          <sup>
                            {{
                              String(
                                (
                                  parseFloat(item.sales_price) +
                                  parseFloat(item.directReductionPrice)
                                ).toFixed(2)
                              ).slice(
                                String(
                                  (
                                    parseFloat(item.sales_price) +
                                    parseFloat(item.directReductionPrice)
                                  ).toFixed(2)
                                ).indexOf('.'),
                                String(
                                  (
                                    parseFloat(item.sales_price) +
                                    parseFloat(item.directReductionPrice)
                                  ).toFixed(2)
                                ).length
                              )
                            }}
                          </sup>
                        </span>
                        <span class="smallprice">
                          <sub>到手价¥</sub>
                          <b>
                            {{
                              String(parseFloat(item.sales_price).toFixed(2)).slice(
                                0,
                                String(parseFloat(item.sales_price).toFixed(2)).indexOf('.')
                              )
                            }}
                          </b>
                          <sup>
                            {{
                              String(parseFloat(item.sales_price).toFixed(2)).slice(
                                String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'),
                                String(parseFloat(item.sales_price).toFixed(2)).length
                              )
                            }}
                          </sup>
                        </span>
                      </div>
                      <div v-else-if="item.fullDiscountPrice">
                        <span class="smallprice grayPrice">
                          <sub>¥</sub>
                          <b>
                            {{
                              String(
                                (
                                  parseFloat(item.sales_price) + parseFloat(item.fullDiscountPrice)
                                ).toFixed(2)
                              ).slice(
                                0,
                                String(
                                  (
                                    parseFloat(item.sales_price) +
                                    parseFloat(item.fullDiscountPrice)
                                  ).toFixed(2)
                                ).indexOf('.')
                              )
                            }}
                          </b>
                          <sup>
                            {{
                              String(
                                (
                                  parseFloat(item.sales_price) + parseFloat(item.fullDiscountPrice)
                                ).toFixed(2)
                              ).slice(
                                String(
                                  (
                                    parseFloat(item.sales_price) +
                                    parseFloat(item.fullDiscountPrice)
                                  ).toFixed(2)
                                ).indexOf('.'),
                                String(
                                  (
                                    parseFloat(item.sales_price) +
                                    parseFloat(item.fullDiscountPrice)
                                  ).toFixed(2)
                                ).length
                              )
                            }}
                          </sup>
                        </span>
                        <span class="smallprice">
                          <sub>折后单价¥</sub>
                          <b>
                            {{
                              String(parseFloat(item.sales_price).toFixed(2)).slice(
                                0,
                                String(parseFloat(item.sales_price).toFixed(2)).indexOf('.')
                              )
                            }}
                          </b>
                          <sup>
                            {{
                              String(parseFloat(item.sales_price).toFixed(2)).slice(
                                String(parseFloat(item.sales_price).toFixed(2)).indexOf('.'),
                                String(parseFloat(item.sales_price).toFixed(2)).length
                              )
                            }}
                          </sup>
                        </span>
                      </div>
                      <p
                        v-if="
                          item.isdeposit == 0 &&
                            item.inventory == 1 &&
                            (item.canbuycnt <= 0 || item.islimit == 2 || item.issale == 0)
                        "
                        style="width: 100%;color: #333;font-size: 0.12rem"
                      >
                        已售磬，请重新选择商品规格
                      </p>
                    </div>
                    <van-stepper
                      @blur="num(item)"
                      :long-press="false"
                      integer
                      @change="stepperFn(item)"
                      @minus="num(item)"
                      @plus="num(item)"
                      class="goods_stepper"
                      v-if="
                        item.islimit == 0 &&
                          (parseInt(item.canbuycnt) > 0 && item.issale != 0) &&
                          item.is_can_buy != 0 &&
                          !item.isdeposit
                      "
                      v-model="item.num"
                      @overlimit="overlimit(item)"
                      :min="1"
                      :max="parseInt(item.canbuycnt)"
                    />
                  </div>
                  <div
                    class="f0 tag flex-ac"
                    v-if="item.fullMonusRules && item.fullMonusRules.actLabel"
                  >
                    <van-tag class="tag_danger" type="danger">
                      {{ item.fullMonusRules.actLabel }}
                    </van-tag>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="act_desc_tag"
              v-if="
                parseInt(item.ispresale) == 1 ||
                  parseInt(item.isdiscount) == 1 ||
                  parseInt(item.isfullgift) == 1 ||
                  parseInt(halfprice.halfpricestatus) == 1 ||
                  parseInt(item.isFullDiscount) == 1 ||
                  parseInt(item.ismorediscounts) == 1
              "
              @click="showActDesc(item)"
            >
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.ispresale) == 1">
                预售
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isdiscount) == 1">
                {{ discountrule.actlabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="parseInt(item.isfullgift) == 1">
                {{ fullgiftrule.actlabel ? fullgiftrule.actlabel : '满赠' }}
              </van-tag>
              <van-tag
                color="#FEE9E6"
                text-color="#F12A0E"
                v-if="parseInt(halfprice.halfpricestatus) == 1 && item.ishalf == 1"
              >
                {{ halfprice.halfactlabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="item.isFullDiscount">
                限时折扣
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="item.ismorediscounts == 1">
                {{ item.morediscountslabel }}
              </van-tag>
              <van-tag color="#FEE9E6" text-color="#F12A0E" v-if="item.isbuygift == 1">
                买赠
              </van-tag>
              <van-icon name="arrow" />
            </div>
            <div class="act_desc_time" v-if="parseInt(item.ispresale) == 1">
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ item.presaletime }}</div>
            </div>
            <div class="act_desc_time" v-if="item.isdeposit == 1">
              <img src="../../assets/images/presell.png" />
              <div class="txt" v-if="item.finalpaystatus == 0">
                {{ dateFn(item.finalpaymenttime, 'datetimestr') }}开始支付尾款
              </div>
              <div class="txt" v-if="item.finalpaystatus == 1">
                {{ dateFn(item.finalpaymenttime, 'datetimestr') }}截止支付尾款
              </div>
            </div>
            <div class="act_desc" v-if="item.rulelist">【秒杀】秒杀活动开始时间还剩 08:12:00</div>
          </div>
        </div>
        <div
          style="margin-top: 0.1rem;padding: 0.15rem 0.11rem 0.71rem;background: #fff;"
          v-if="list && list.length > 0 && productlist && productlist.length > 0 && recommend"
          :skuSwitch="'1'"
        >
          <product-list
            :title="title"
            :productlist="productlist"
            :skuSwitch="'1'"
            @addCartHandler="addCartHandler"
            :markPointData="{ scenepoint: 'ITEMCART', scenedesc: 'recom' }"
          ></product-list>
        </div>
      </Scroller>
      <div style="height: 100%;" v-if="nodata && list && list.length <= 0">
        <div
          class="skinTest"
          ref="skinTest"
          style="margin-top: 0.05rem"
          v-if="!advertis && skinTest && $store.state.skinTextCartShow == 1"
        >
          <skinTest :page="'cart'"></skinTest>
        </div>
        <div class="skinTest" style="margin-top: 0.05rem" v-if="advertis">
          <advertisingSpace></advertisingSpace>
        </div>
        <act-coupon></act-coupon>
        <div
          class="couponmsg flex-js-ac"
          v-if="topmsg && (topmsg.type == 2 || topmsg.type == 3)"
          style="width: 100%;"
          @click="$router.push('/cashcoupon' + (topmsg.type == 3 ? '?navIndex=1' : ''))"
        >
          <div class="flex-ac">
            <div class="couponImg">
              <img
                class="flex-1"
                :src="topmsg.type == 3 ? topmsg.img_path : '/static/images/coupon@2x.png'"
              />
              <span v-if="topmsg.type == 2" class="f13 color-FC0324">{{ topmsg.couponmoney }}</span>
            </div>
            <div>
              <p class="f13" style="color: #333333;font-weight: bold;margin-bottom: 0.03rem">
                {{ topmsg.message1 }}
              </p>
              <p class="f12" style="color: #6C6C6C;">{{ topmsg.message2 }}</p>
            </div>
          </div>
          <div class="f13 flex-ac color-FC0324">
            卡券包
            <van-icon name="arrow" color="#FC0324" />
          </div>
        </div>
        <div
          class="nodata"
          v-if="nodata && productlist && productlist.length > 0"
          ref="nodata"
          style="margin-top: 0.1rem"
        >
          <img src="../../assets/images/nocartd.png" />
          <div class="msg">购物车快饿瘪了T.T</div>
          <div class="gobtn" @click="goList">去逛逛</div>
        </div>
        <div
          class="nodata"
          v-if="nodata && productlist && productlist.length <= 0"
          ref="nodata"
          style="height: calc(86vh);margin-top: 0.1rem"
        >
          <empty :path="'noCart'"></empty>
        </div>
        <div
          style="margin-top: 0.1rem;padding: 0.15rem 0.1rem 0.11rem;background: #fff;"
          v-if="list && list.length <= 0 && (productlist && productlist.length > 0) && recommend"
        >
          <product-list
            :title="title"
            :productlist="productlist"
            :skuSwitch="'1'"
            @addCartHandler="addCartHandler"
            :markPointData="{ scenepoint: 'ITEMCART', scenedesc: 'recom' }"
          ></product-list>
        </div>
      </div>
    </div>
    <!--    折上折-->
    <div
      class="additemMsg footerIOS"
      @click="goflod('flod')"
      v-if="FlodMsg && discountrule.discountenable == 1 && (list && list.length > 0)"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FlodMsg"></div>
      </div>
      <div class="btn" v-if="parseInt(goodsnum) < parseInt(discountrule.discountlist[0].itemnum)">
        去凑单>
      </div>
    </div>
    <!--    限时折扣-->
    <div
      class="additemMsg footerIOS"
      @click="goflod('fulldiscount')"
      v-if="FlodMsg && fullDiscountRule.discountenable == 1 && (list && list.length > 0)"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FlodMsg"></div>
      </div>
      <div class="btn" v-if="parseInt(goodsnum) < parseInt(fullDiscountRule.rulelist[0].num)">
        去凑单>
      </div>
    </div>
    <!--    满赠-->
    <div
      class="additemMsg footerIOS"
      @click="gofullgift"
      v-if="FullGiftMsg && fullgiftrule.actstatus == 1 && (list && list.length > 0)"
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FullGiftMsg"></div>
      </div>
      <div
        class="btn"
        v-if="parseFloat(currentfullgiftmoney) < parseFloat(fullgiftrule.rulelist[0].allmoney)"
      >
        去凑单>
      </div>
    </div>
    <div class="pro_submit footerIOS" v-if="goodsDelShow == false && (list && list.length > 0)">
      <div class="pro_tools">
        <van-checkbox @click="checkedAll" checked-color="#FC0324" v-model="ischooseAll">
          全选
        </van-checkbox>
        <!--:style="discountrule.discountenable == 1 || fullgiftrule.actstatus == 1 ? {} : {'margin-top': '0.13rem'}"-->
        <div class="pro_total_details">
          <div class="total">
            <div class="totalprice">
              <div class="ppo">
                <div class="totalname">合计:</div>
                <div class="smallprice">
                  <sub>¥</sub>
                  {{ parseFloat(totalmoney).toFixed(2) }}
                </div>
              </div>
              <div class="ppo">
                <div class="oldprice">¥{{ parseFloat(oldtotalmoney).toFixed(2) }}</div>
                <div
                  class="offerdetails"
                  v-if="
                    discountrule.discountenable == 1 ||
                      fullgiftrule.actstatus == 1 ||
                      fullDiscountRule.discountenable == 1 ||
                      morediscountsmoney > 0 ||
                      fullminusmoney > 0
                  "
                  @click="showofferdetails = true"
                >
                  <div class="flp">优惠明细</div>
                  <img src="../../assets/images/upred.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="{
            settlement: true,
            disabled:
              list && list.filter((item) => item.ischoose == true || item.ischoose == 1).length <= 0
          }"
          @click="settlement"
        >
          去结算({{ totalnum }})
        </div>
      </div>
    </div>
    <div class="pro_submit footerIOS" v-if="goodsDelShow == true && (list && list.length > 0)">
      <div class="pro_tools">
        <van-checkbox v-model="ischooseAll" checked-color="#FC0324" @click="checkedAll">
          全选
        </van-checkbox>
        <div class="choosetxt">已选{{ totalnum }}件</div>
        <div style="flex: 1;-webkit-flex: 1;-moz-flex: 1;-ms-flex: 1;-o-flex: 1;">
          <div class="del" @click="del">删除</div>
          <div class="coll" @click="collect">移入收藏夹</div>
        </div>
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <footer-comp :footerIndex="index" :cartnum="cartnum"></footer-comp>
    <!--:quota-used="5"-->
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :goods-id="productId"
      :quota="maxNum"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
              <span v-if="skucostprice" class="van-sku__costprice-symbol">¥</span>
              <span v-if="skucostprice" class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <!--<van-overlay :show="showofferdetails" @click="showofferdetails = false" :z-index="98"/>-->
    <div style="z-index: 2000; position: fixed">
      <van-action-sheet
        v-model="showofferdetails"
        title="优惠明细"
        class="offer"
        close-on-click-overlay
      >
        <div class="offerdetailsdis">
          <div class="ofd1">*实际优惠金额以下单页为准</div>
          <div class="list">
            <div class="item goodstotalprice">
              <div class="tit">商品总额</div>
              <div class="value">¥{{ parseFloat(saletotalmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="fullminusmoney > 0">
              <div class="tit flex-ac">
                全场满减&nbsp;
                <van-tag v-if="fullMinusRules.actLabel" class="tag_danger" type="danger">
                  {{ fullMinusRules.actLabel }}
                </van-tag>
              </div>
              <div class="value">-¥{{ parseFloat(fullminusmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="fullDiscountmoney">
              <div class="tit">{{ fullDiscountRule.actlabel }}</div>
              <div class="value">-¥{{ parseFloat(fullDiscountmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="discountrule.discountenable == 1">
              <div class="tit">{{ discountrule.name }}</div>
              <div class="value">-¥{{ parseFloat(discounmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="parseFloat(morediscountsmoney) > 0">
              <div class="tit">多件立减</div>
              <div class="value">-¥{{ parseFloat(morediscountsmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="parseFloat(directReductionmoney) > 0">
              <div class="tit">直降活动</div>
              <div class="value">-¥{{ parseFloat(directReductionmoney).toFixed(2) }}</div>
            </div>
            <div class="item" v-if="presalerule.actstatus == 1">
              <div class="tit">定金翻倍(含定金)</div>
              <div class="value">-¥{{ parseFloat(deposittotalmoney).toFixed(2) }}</div>
            </div>
            <div class="item combined">
              <div class="tit">合计</div>
              <div class="value">¥{{ parseFloat(totalmoney).toFixed(2) }}</div>
            </div>
            <div class="item desc">
              <div class="tit">(未计算运费、现金券、金币，请在下单页查看)</div>
            </div>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <!--活动服务-->
    <div class="presale_info_dialog" v-if="showPresale == true">
      <div class="dialog">
        <div class="header1">
          <div class="van-divider">预售购买</div>
        </div>
        <div class="content">
          {{ presaledescpt }}
        </div>
        <div class="btn" @click="presell">我知道了</div>
      </div>
    </div>
    <!--活动服务-->
    <van-action-sheet v-model="showaction" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div class="tit">
            <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
            {{ item.name }}
          </div>
          <div class="con" v-if="item.statusmsg">
            {{ item.statusmsg }}
          </div>
          <div class="con" v-html="item.desc.replace(/\n/g, '<br/>')"></div>
        </div>
        <div class="btn">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { Divider, Checkbox, CheckboxGroup, Stepper, Sku, Tag, Overlay } from 'vant'
import productItem from '../common/productItem'
import footerComp from '../common/footerComp'
import skinTest from '../common/skinTest'
import advertisingSpace from '../common/advertisingSpace'
import productList from '../common/productList'
import empty from '../emptypage/empty'
import follow from '../common/follow'
import {
  isWeixin,
  kefu,
  fenxiang,
  cartNum,
  download_dialog,
  isWx
} from '../../assets/common/js/config'
import Scroller from '../common/Scroller'
import actCoupon from '../common/coupon'

export default {
  name: 'cart',
  components: {
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Stepper.name]: Stepper,
    [Sku.name]: Sku,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    productItem,
    footerComp,
    skinTest,
    productList,
    empty,
    Scroller,
    follow,
    actCoupon,
    advertisingSpace
  },
  data() {
    return {
      follow: null,
      showaction: false,
      sureGray: false,
      msglist: [],
      presaledescpt: '',
      showPresale: false,
      showofferdetails: false,
      currentdiscount: 0,
      goodsnum: 0,
      FlodMsg: '',
      FullGiftMsg: '',
      discountrule: {},
      fullgiftrule: {},
      presalerule: {},
      halfprice: {},
      ischooseAll: 0,
      checkAll: null, // 记录是否是点击全选按钮选中 选中状态 1是 0否
      index: 3,
      value: 1,
      goodsDelShow: false,
      singleChecked: false,
      list: [],
      recommend: false,
      productlist: [],
      title: '为你推荐',
      listItem: {},
      itemIndex: null,
      showsku: false,
      skuname: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      skuprice: '197.00-218.90',
      skucostprice: '',
      productId: null,
      maxNum: null,
      totalmoney: 0,
      oldtotalmoney: 0,
      discounmoney: 0,
      deposittotalmoney: 0,
      currentfullgiftmoney: 0,
      saletotalmoney: 0,
      totalnum: 0,
      isChooseProduct: [],
      skinTest: false,
      advertis: false,
      nodata: false,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            let msg = `数量超出范围~`
            this.$toast(msg)
            // console.log(limitType)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productNum: 0,
      directReductionmoney: 0, // 直降活动
      fullDiscountRule: {}, // 限时折扣
      fullDiscountmoney: 0,
      cartnum: 0,
      topmsg: null,
      morediscountsmoney: 0, // n件立减
      morediscounts: {}, // n件立减金额
      fullsubtractTotalmoney: 0, // 满减活动 参与满减商品总金额
      fullMinusRules: {}, // 满减活动
      fullminusmoney: 0, // 满减优惠金额
      fullMinusMsg: '', // 满减优惠提示
      fullMinus_totalmoney: 0, // 参与满减的总金额
      fixedStyle: {},
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  mounted: function() {
    var startTime = new Date('2021/02/25 10:00:00').getTime()
    var currTime = new Date().getTime()
    var endTime = new Date('2021/03/03 23:59:59').getTime()
    if (currTime >= startTime && currTime < endTime) {
      this.advertis = true
    } else {
      this.advertis = false
    }
    if (!isWeixin()) {
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$store.commit('SKIN_PATH', 'cart')
        this.$store.commit('PATH_VALUE', '')
      }
    } else {
      fenxiang({ path: 'cart' })
    }
    // this.nowPage = 1
    // this.list = []
    // this.recommend = false
    // this.getData()
  },
  activated: function() {
    if (this.$store.state.addCartInitData == 1) {
      this.$store.commit('ADD_CART_INIT_DATA', 0)
      this.recommend = false
      this.nowPage = 0
      this.onInfinite()
    }
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
    sessionStorage.removeItem('choose_coupon')
    sessionStorage.removeItem('choose_product')
  },
  beforeRouteEnter(to, from, next) {
    console.log(from)
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.recommend = false
        vm.nowPage = 0
        vm.getHeadData()
      })
    } else {
      next((vm) => {
        cartNum((num) => (vm.cartnum = num))
        vm.getHeadData()
        if (!isWeixin()) {
          if (vm.waptoken.waptoken && vm.waptoken.waptoken == vm.waptoken.tourists) {
            vm.$store.commit('SKIN_PATH', 'cart')
            vm.$store.commit('PATH_VALUE', '')
          }
        }
        // vm.recommend = false
        // vm.nowPage = 0
        // vm.list = []
        // vm.onInfinite()
        // console.log('定位滚动')
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        // setTimeout(function () {
        // window.scrollTo(0, sessionStorage.askPositon, false)
        // document.getElementById('cup').scrollTo(0, sessionStorage.askPositon, false)
        // }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    // sessionStorage.askPositon = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
    // console.log('scrollTop', document.body.scrollTop)
    // console.log('scrollTop1', document.documentElement.scrollTop)
    // console.log('scrollTop2', window.scrollTop)
    // console.log('askPositon', sessionStorage.askPositon)
    next()
  },
  methods: {
    newpersontask() {
      window.location = this.newpersonjump
    },
    fixedFn: function(isFixed) {
      this.fixedStyle = {}
      if (isFixed) this.fixedStyle = { 'margin-top': '0.38rem', padding: '0 0.1rem' }
    },
    getHeadData: function() {
      var urlHead = this.$ajax.getTopMessage_URL
      // 登录校验
      this.$customRequestAjax(urlHead).then((res) => {
        if (res.data.code === 200) {
          this.topmsg = res.data ? res.data : null
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    getData: function() {
      var urlShop =
        this.$ajax.getShoppingCart_URL + '?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
      var recommentUrl = this.$ajax.getRecommendByShoppingCart_URL
      var that = this
      that.$customRequestAjax(urlShop).then((res) => {
        if (res.data.code == 200) {
          if (that.nowPage == 1) {
            if (res.data.cartlist.length <= 0) {
              that.skinTest = true
              that.nodata = true
            } else {
              that.nodata = false
              res.data.cartlist.map((item) => {
                item.temp_sales_price = item.sales_price
                var indexWh = 0
                var indexDs = 0
                if (item.isdeposit == 1) {
                  item.sku_rule_list.map((itemSon) => {
                    itemSon.temp_sales_price = itemSon.sales_price
                    if (itemSon.canbuycnt <= 0 || itemSon.islimit == 2 || item.is_can_buy == 0) {
                      indexWh++
                    }
                    if (itemSon.islimit == 1) {
                      indexDs++
                    }
                  })
                } else {
                  item.sku_rule_list.map((itemSon) => {
                    itemSon.temp_sales_price = itemSon.sales_price
                    if (
                      itemSon.canbuycnt <= 0 ||
                      itemSon.islimit == 2 ||
                      itemSon.issale == 0 ||
                      item.is_can_buy == 0
                    ) {
                      indexWh++
                    }
                    if (itemSon.islimit == 1) {
                      indexDs++
                    }
                  })
                }
                if (
                  item.sku_rule_list &&
                  item.sku_rule_list.length <= indexWh &&
                  item.sku_rule_list.length > indexDs
                ) {
                  item.inventory = 0 // 无货状态
                } else {
                  item.inventory = 1 // 有货状态
                }
                if (
                  item.islimit != 0 ||
                  parseInt(item.canbuycnt) <= 0 ||
                  item.issale == 0 ||
                  item.is_can_buy == 0
                ) {
                  item.ischoose = 0
                }
              })
            }
            that.list = res.data.cartlist
            that.refresh = false
          } else {
            res.data.cartlist.map((item) => {
              item.temp_sales_price = item.sales_price
              var indexWh = 0
              var indexDs = 0
              that.customStepperConfig.stockNum = item.canbuycnt
              if (item.isdeposit == 1) {
                item.sku_rule_list.map((itemSon) => {
                  itemSon.temp_sales_price = itemSon.sales_price
                  if (itemSon.canbuycnt <= 0 || itemSon.islimit == 2 || item.is_can_buy == 0) {
                    indexWh++
                  }
                  if (itemSon.islimit == 1) {
                    indexDs++
                  }
                })
              } else {
                item.sku_rule_list.map((itemSon) => {
                  itemSon.temp_sales_price = itemSon.sales_price
                  if (
                    itemSon.canbuycnt <= 0 ||
                    itemSon.islimit == 2 ||
                    itemSon.issale == 0 ||
                    item.is_can_buy == 0
                  ) {
                    indexWh++
                  }
                  if (itemSon.islimit == 1) {
                    indexDs++
                  }
                })
              }
              if (item.sku_rule_list && item.sku_rule_list.length <= indexWh) {
                item.inventory = 0
              } else {
                item.inventory = 1
              }
              if (
                item.islimit != 0 ||
                parseInt(item.canbuycnt) <= 0 ||
                item.issale == 0 ||
                item.is_can_buy == 0
              ) {
                item.ischoose = 0
              }
            })
            that.list = that.list.concat(res.data.cartlist)
          }
          that.discountrule = res.data.discountrule
          that.presalerule = res.data.presalerule
          that.halfprice = {
            halfpricestatus: res.data.halfpricestatus,
            halfpricedesc: res.data.halfpricedesc,
            halfactname: res.data.halfactname,
            halfactlabel: res.data.halfactlabel
          }
          if (res.data.fullMinusRules && Object.keys(res.data.fullMinusRules).length) {
            that.fullMinusRules = res.data.fullMinusRules
          }
          that.presaledescpt = res.data.presaledescpt
          that.fullgiftrule = res.data.fullgiftrule
          that.fullDiscountRule = res.data.fullDiscountRule || {}
          that.morediscounts = res.data.morediscounts || {}
          that.loading = false
          that.checkedSingle()
          if (res.data.cartlist.length < that.pagesize) {
            that.finished = true
            that.recommend = true
            that.$customRequestAjax(recommentUrl).then((res) => {
              if (res.data.code == 200) {
                that.productlist = res.data.itemlist
              }
            })
          } else {
            that.recommend = false
            that.finished = false
          }
        } else if (res.data.code == 10000) {
          that.skinTest = true
          that.nodata = true
          setTimeout(function() {
            // that.$nextTick(function () {
            //   that.$refs.skinTest.style.display = 'block'
            //   that.$refs.nodata.style.display = 'block'
            // })
            that.recommend = true
          })
        }
      })
    },
    // // 判断该商品是否在正常销售和上架
    // normal: function (idx, str) {
    //   var len = this.list[idx].sku_rule_list
    //   for (var i = 0; i < len.length; i++) {
    //     if (this.list[idx].skuid == len[i].skuid) {
    //       if (str == 'issale') {
    //         return len[i].issale
    //       }
    //       if (str == 'islimit') {
    //         return len[i].islimit
    //       }
    //     }
    //   }
    // },
    followFn: function(data) {
      this.follow = data
    },
    addCartHandler: function() {
      this.recommend = false
      this.nowPage = 0
      this.onInfinite()
    },
    onRefresh() {
      this.refresh = true
      this.recommend = false
      this.nowPage = 1
      // this.list = []
      this.getData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      this.recommend = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData()
      // }, 400)
    },
    stepperFn(items) {
      var that = this
      if (items.num < 0) items.num = Math.abs(items.num)
      setTimeout(function() {
        if (!that.goodsDelShow) {
          that.fullDiscountRuleFn()
          that.totalMoney()
        }
      })
    },
    goList() {
      this.$router.push('/classification')
    },
    changeEdit() {
      this.goodsDelShow = !this.goodsDelShow
      let list = null
      // console.log('goodsDelShow', this.goodsDelShow)
      var that = this
      if (!this.goodsDelShow) {
        var noAllIndex = 0
        var allIndex = 0
        list = that.list.map(function(item, i) {
          if (
            item.isdeposit == 0 &&
            (item.islimit != 0 ||
              item.issale == 0 ||
              parseInt(item.canbuycnt) <= 0 ||
              item.is_can_buy == 0)
          ) {
            item.ischoose = false
            noAllIndex++
          } else if (
            item.isdeposit == 1 &&
            (item.finalpaystatus == 0 ||
              item.islimit != 0 ||
              parseInt(item.canbuycnt) <= 0 ||
              item.is_can_buy == 0)
          ) {
            item.ischoose = false
            noAllIndex++
          } else {
            if (that.ischooseAll && item.isdeposit == 1 && item.finalpaystatus == 1) {
              item.ischoose = true
            }
            if (item.ischoose) {
              allIndex++
            }
          }
          return item
        })
        if (list.length > noAllIndex && list.length - noAllIndex <= allIndex) {
          that.ischooseAll = true
        } else {
          that.ischooseAll = false
        }
        this.list = list
      } else {
        var noAllIndex = 0
        var allIndex = 0
        list = that.list.map(function(item, i) {
          if (
            item.islimit != 0 ||
            item.issale == 0 ||
            parseInt(item.canbuycnt) <= 0 ||
            item.issale == 0 ||
            item.is_can_buy == 0
          ) {
            if (that.ischooseAll) {
              item.ischoose = true
            }
          }
          if (item.isdeposit == 1) {
            item.ischoose = false
            noAllIndex++
          } else {
            if (item.ischoose) {
              allIndex++
            }
          }
          return item
        })
        if (list.length > noAllIndex && list.length - noAllIndex <= allIndex) {
          that.ischooseAll = true
        } else {
          that.ischooseAll = false
        }
        this.list = list
      }
      // console.log('ischooseAll', this.ischooseAll)
    },
    presell() {
      this.showPresale = false
      this.settlement()
    },
    settlement() {
      var that = this
      var shopConfirmResult = {
        skuidArr: [],
        itemNum: [],
        skuidArrOversea: [],
        from: 1,
        orderfrom: 0,
        itemNumOversea: [],
        totalmoney:
          that.totalmoney +
          that.discounmoney +
          that.fullDiscountmoney +
          that.morediscountsmoney +
          that.fullminusmoney,
        totalnum: that.totalnum,
        liveId: [],
        roomId: [],
        LiveIdArrOversea: [],
        roomIdArrOversea: [],
        course_params: []
      }
      if (
        !(
          this.list &&
          this.list.filter((item) => item.ischoose == true || item.ischoose == 1).length <= 0
        )
      ) {
        var ispresale = 0
        that.isChooseProduct.forEach(function(item) {
          if (item.courseid) shopConfirmResult.course_params.push(item.skuid + '_' + item.courseid)

          if (item.isoversea == 1) {
            shopConfirmResult.skuidArrOversea.push(item.skuid)
            shopConfirmResult.itemNumOversea.push(item.num)
            shopConfirmResult.LiveIdArrOversea.push(item.live_id)
            shopConfirmResult.roomIdArrOversea.push(item.room_id)
          } else {
            shopConfirmResult.skuidArr.push(item.skuid)
            shopConfirmResult.itemNum.push(item.num)
            shopConfirmResult.liveId.push(item.live_id)
            shopConfirmResult.roomId.push(item.room_id)
          }
          if (item.ispresale == 1) {
            ispresale = 1
          }
        })
        if (
          this.showPresale == false &&
          ispresale == 1 &&
          !localStorage.getItem('itemcartpresale')
        ) {
          that.showPresale = true
          localStorage.setItem('itemcartpresale', '1')
        } else {
          var urlCheck
          if (
            shopConfirmResult.skuidArr.length > 0 &&
            shopConfirmResult.skuidArrOversea.length <= 0
          ) {
            urlCheck =
              that.$ajax.checkOrder_URL +
              '?skuids=' +
              shopConfirmResult.skuidArr.join() +
              '&buynum=' +
              shopConfirmResult.itemNum.join()
            that.$customRequestAjax(urlCheck).then((res) => {
              if (res.data.code == 200) {
                localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
                sessionStorage.removeItem('choose_integral')
                sessionStorage.removeItem('choose_coupon')
                sessionStorage.removeItem('choose_product')
                sessionStorage.removeItem('oversea_List')
                // 埋点
                that.dataCollection()
                that.$router.push('/order')
              } else {
                that.nowPage = 0
                that.onInfinite()
                // that.onRefresh()
              }
            })
          } else if (
            shopConfirmResult.skuidArrOversea.length > 0 &&
            shopConfirmResult.skuidArr.length <= 0
          ) {
            // 为了使普通商品和海外商品的确认订单接口参数key值保持一致
            shopConfirmResult.skuidArr = shopConfirmResult.skuidArrOversea
            shopConfirmResult.itemNum = shopConfirmResult.itemNumOversea
            shopConfirmResult.liveId = shopConfirmResult.LiveIdArrOversea
            shopConfirmResult.roomId = shopConfirmResult.roomIdArrOversea
            shopConfirmResult.skuidArrOversea = []
            shopConfirmResult.itemNumOversea = []
            shopConfirmResult.LiveIdArrOversea = []
            shopConfirmResult.roomIdArrOversea = []
            if (isWx != 3) {
              // wap端可支付宝支付海外商品
              download_dialog(that)
              return
            }
            urlCheck =
              that.$ajax.checkOrder_URL +
              '?skuids=' +
              shopConfirmResult.skuidArr.join() +
              '&buynum=' +
              shopConfirmResult.itemNum.join()
            that.$customRequestAjax(urlCheck).then((res) => {
              if (res.data.code == 200) {
                localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
                sessionStorage.removeItem('choose_integral')
                sessionStorage.removeItem('choose_coupon')
                sessionStorage.removeItem('choose_product')
                sessionStorage.removeItem('oversea_List')
                // 埋点
                that.dataCollection()
                that.$router.push('/order')
              } else {
                that.onRefresh()
              }
            })
          } else {
            that.$toast('海外商品不能与普通商品一起购买')
          }
        }
      }
    },
    dataCollection() {
      let list = this.isChooseProduct
      for (let i in list) {
        let params = {
          productId_var: list[i].itemid, // 商品id
          productName_var: list[i].name, // 商品名称
          firstCat_var: '', // 商品一级分类
          productType_var: '', // 商品品类
          productFormat_var: list[i].skuid, // 商品规格
          buyQuantity_var: list[i].num, // 购买数量
          payAmount_var: (list[i].sales_price * list[i].num).toFixed(2) // 支付金额
        }
        gio('track', 'settleProduct', params)
      }
    },
    del() {
      var urlDel = this.$ajax.delShoppingCart_URL
      var that = this
      var deleteProduct = {
        skuIds: [],
        skuIndex: []
      }
      deleteProduct.skuIds = []
      deleteProduct.skuIndex = []
      this.list.map(function(item, index) {
        if (item.ischoose) {
          deleteProduct.skuIds.push(item.skuid)
          deleteProduct.skuIndex.unshift(index)
        }
      })
      var data = {
        skuids: deleteProduct.skuIds.join()
      }
      if (deleteProduct.skuIds && deleteProduct.skuIds.length > 0) {
        that.$dialog
          .confirm({
            // title: '暂无消息',
            message: '你确认将这' + deleteProduct.skuIds.length + '个宝贝删除？',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            cancelButtonText: '我再想想',
            confirmButtonText: '删除'
          })
          .then(() => {
            // on confirm
            that.$customRequestAjax.post(urlDel, data).then((res) => {
              if (res.data.code == 200) {
                deleteProduct.skuIndex.map(function(item, index) {
                  that.list.splice(item, 1)
                })
                if (that.list.length <= 0) {
                  that.nowPage = 0
                  that.list = []
                  that.onInfinite()
                  // setTimeout(function () {
                  //   that.$refs.skinTest.style.display = 'block'
                  //   that.$refs.nodata.style.display = 'block'
                  // })
                }
              }
            })
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.$toast('请选择商品')
      }
    },
    collect() {
      var urlColl = this.$ajax.addCollection_URL
      var urlDel = this.$ajax.delShoppingCart_URL
      var that = this
      var product = {
        skuIds: [],
        skuIndex: [],
        itemId: []
      }
      product.skuIds = []
      product.skuIndex = []
      this.list.map(function(item, index) {
        if (item.ischoose) {
          product.skuIds.push(item.skuid)
          product.itemId.push(item.itemid)
          product.skuIndex.unshift(index)
        }
      })
      var dataColl = {
        itemids: product.itemId.join()
      }
      if (product.itemId && product.itemId.length > 0) {
        this.$customRequestAjax.post(urlColl, dataColl).then((res) => {
          if (res.data.code == 200) {
            this.$toast('收藏成功')
          }
        })
      } else {
        this.$toast('请选择商品')
      }
      // var dataDel = {
      //   'skuids': product.skuIds.join()
      // }
      // this.$customRequestAjax.post(urlDel, dataDel).then(res => {
      //   if (res.data.code == 200) {
      //     product.skuIndex.map(function (item, index) {
      //       that.list.splice(item, 1)
      //     })
      //   }
      // })
    },
    checkedAll() {
      let that = this
      that.checkAll = 1
      console.log(this.ischooseAll)
      let list = null
      if (that.goodsDelShow) {
        list = this.list.map(function(item, i) {
          if (item.isdeposit == 0) {
            item.ischoose = that.ischooseAll
          }
          return item
        })
      } else if (!that.goodsDelShow) {
        list = that.list.map(function(item, i) {
          if (item.isdeposit == 0) {
            if (
              item.islimit == 0 &&
              item.issale == 1 &&
              parseInt(item.canbuycnt) > 0 &&
              item.issale != 0 &&
              item.is_can_buy != 0
            ) {
              item.ischoose = that.ischooseAll
            }
          } else {
            if (
              item.finalpaystatus == 1 &&
              item.islimit == 0 &&
              parseInt(item.canbuycnt) > 0 &&
              item.is_can_buy != 0
            ) {
              item.ischoose = that.ischooseAll
            }
          }
          return item
        })
      }
      this.list = list
      console.log(this.list, that.ischooseAll)
      var datas = {
        isall: 1,
        ischoose: this.ischooseAll ? 1 : 0
      }
      this.updateProduct(datas)
    },
    checkedSingle() {
      let list = this.list.filter((item) => item.ischoose == true || item.ischoose == 1)
      var stocklist
      if (this.goodsDelShow) {
        stocklist = this.list.filter((item, index) => item.isdeposit == 0)
        // stocklist = this.list.filter(item => item.islimit == 0)
      } else if (!this.goodsDelShow) {
        stocklist = this.list.filter((item, index) =>
          item.isdeposit == 0
            ? item.islimit == 0 &&
              item.issale == 1 &&
              parseInt(item.canbuycnt) > 0 &&
              item.issale != 0 &&
              item.is_can_buy != 0
            : item.finalpaystatus == 1 &&
              item.islimit == 0 &&
              parseInt(item.canbuycnt) > 0 &&
              item.is_can_buy != 0
        )
      }
      // console.log(stocklist)
      if (list.length >= stocklist.length && stocklist.length > 0) {
        this.ischooseAll = 1
      } else {
        this.ischooseAll = 0
      }
      this.isChooseProduct = this.list.filter((item) => item.ischoose == true || item.ischoose == 1)
      this.totalnum = 0
      this.totalnum = this.isChooseProduct.length
      this.fullDiscountRuleFn()
      this.totalMoney()
      // console.log(this.isChooseProduct)
    },
    checkedSingleFn(items) {
      // console.log(items)
      var datas = {
        skuid: items.skuid,
        num: items.num,
        new_skuid: items.skuid,
        ischoose: items.ischoose ? 1 : 0,
        isall: this.ischooseAll ? 1 : 0
      }
      if (
        items.inventory != 0 &&
        items.islimit == 0 &&
        (parseInt(items.canbuycnt) > 0 && items.issale != 0) &&
        items.is_can_buy != 0
      ) {
        this.updateProduct(datas)
      }
    },
    fullDiscountRuleFn: function() {
      let chooselen = 0
      this.fullDiscountmoney = 0
      this.isChooseProduct.map((item) => {
        if (item.isFullDiscount == 1) chooselen += parseInt(item.num)
      })
      if (this.fullDiscountRule.rulelist && chooselen > 0) {
        let rulelist = this.fullDiscountRule.rulelist
        for (let i = 0; i < rulelist.length; i++) {
          if (chooselen >= parseInt(rulelist[i].num)) {
            this.list.map((listitem) => {
              if (
                (listitem.ischoose == true || listitem.ischoose == 1) &&
                listitem.isFullDiscount == 1
              ) {
                listitem.fullDiscountPrice =
                  listitem.temp_sales_price -
                  parseFloat(listitem.cost_price) * parseFloat(rulelist[i].discount)
                listitem.sales_price =
                  parseFloat(listitem.cost_price) * parseFloat(rulelist[i].discount)
                this.fullDiscountmoney += listitem.fullDiscountPrice * listitem.num
              } else {
                listitem.sales_price = listitem.temp_sales_price
                  ? listitem.temp_sales_price
                  : listitem.sales_price
                listitem.fullDiscountPrice = 0
              }
            })
            break
          } else if (i == rulelist.length - 1) {
            this.fullDiscountmoney = 0
            this.list.map((listitem) => {
              listitem.sales_price = listitem.temp_sales_price
                ? listitem.temp_sales_price
                : listitem.sales_price
              listitem.fullDiscountPrice = 0
            })
          }
        }
      }
      console.log(this.list)
    },
    onConfirmClicked() {
      // console.log('skuData', this.$refs.sku.getSkuData())
      // console.log('listItem', this.listItem)
      var skuData = this.$refs.sku.getSkuData()
      if (!skuData.selectedSkuComb) {
        return
      }
      var datas = {
        skuid: this.listItem.skuid,
        num: this.productNum,
        new_skuid: skuData.selectedSkuComb.id
      }
      var that = this
      if (skuData.selectedSkuComb.id !== that.listItem.skuid) {
        that.updateProduct(datas, function() {
          that.$nextTick(function() {
            that.initialSku = skuData.selectedSkuComb
            that.initialSku['selectedNum'] = skuData.selectedNum
          })
          that.list[that.itemIndex].islimit = skuData.selectedSkuComb.islimit
          that.list[that.itemIndex].issale = skuData.selectedSkuComb.issale
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          that.list[that.itemIndex].spec = that.skuname
          that.list[that.itemIndex].skuid = skuData.selectedSkuComb.id
          that.list[that.itemIndex].sales_price = skuData.selectedSkuComb.price
          that.list[that.itemIndex].cost_price = skuData.selectedSkuComb.cost_price
          that.list[that.itemIndex].temp_sales_price = skuData.selectedSkuComb.temp_sales_price
          that.list[that.itemIndex].ismorediscounts = skuData.selectedSkuComb.ismorediscounts
          that.list[that.itemIndex].morediscountslabel = skuData.selectedSkuComb.morediscountslabel
          that.list[that.itemIndex].morediscountsmoney = skuData.selectedSkuComb.morediscountsmoney
          that.list[that.itemIndex].morediscountsitemnum =
            skuData.selectedSkuComb.morediscountsitemnum
          that.list[that.itemIndex].issuperposition = skuData.selectedSkuComb.issuperposition
          that.list[that.itemIndex].morediscountdesc = skuData.selectedSkuComb.morediscountdesc
          that.list[that.itemIndex].morediscountsname = skuData.selectedSkuComb.morediscountsname

          if (parseInt(skuData.selectedSkuComb.stock_num) <= that.productNum) {
            that.productNum = skuData.selectedSkuComb.stock_num
          }
          that.list[that.itemIndex].num = that.productNum
          that.list[that.itemIndex].canbuycnt = skuData.selectedSkuComb.stock_num
          if (
            that.list[that.itemIndex].islimit != 0 ||
            parseInt(that.list[that.itemIndex].canbuycnt) <= 0 ||
            that.list[that.itemIndex].issale == 0 ||
            that.list[that.itemIndex].is_can_buy == 0
          ) {
            that.list[that.itemIndex].ischoose = 0
          } else {
            that.fullDiscountRuleFn()
            that.totalMoney()
          }
        })
      }
      // console.log('that.list', that.list)
      this.showsku = false
    },
    updateProduct: function(data, fn) {
      var urlSku = this.$ajax.updateShoppingCart_URL
      this.$customRequestAjax.post(urlSku, data).then((res) => {
        if (res.data.code == 200) {
          if (typeof fn == 'function') {
            fn()
          }
        }
      })
    },
    openSku(items, idx) {
      // items.issale != 0
      if (items.inventory == 1) {
        // && items.issale != 0
        this.productNum = items.num
        this.listItem = items
        this.itemIndex = idx
        this.productId = this.listItem.itemid
        this.maxNum = parseInt(this.listItem.canbuycnt)
        this.goods.title = items.name
        this.skuprice = parseFloat(items.sales_price).toFixed(2)
        this.skucostprice = parseFloat(items.cost_price).toFixed(2)
        this.goods.picture = items.img_path
        this.skuname = items.spec
        var that = this
        that.sku.tree = []
        that.sku.list = []
        that.listItem.normlist.map(function(item, index) {
          that.sku.tree.push({
            k: item.spec_classify_name,
            v: [],
            k_s: 's' + (index + 1)
          })
          item.speclist.map(function(itemSon) {
            that.sku.tree[index].v.push({
              id: itemSon.spec_id,
              name: itemSon.spec_name
            })
          })
        })
        that.listItem.sku_rule_list.map(function(item) {
          // if (item.issale == 1 && item.islimit == 0) {
          var stockNum =
            item.islimit == 2 || item.issale == 0 || item.is_can_buy == 0 || item.is_can_buy == 0
              ? 0
              : parseInt(item.canbuycnt)
          that.sku.list.push({
            id: item.skuid,
            price: parseFloat(item.sales_price).toFixed(2),
            s1: item.spec_group_id.split('_')[0],
            s2: item.spec_group_id.split('_')[1],
            s3: item.spec_group_id.split('_')[2],
            selectedNum: parseInt(item.num),
            stock_num: stockNum,
            islimit: item.islimit,
            issale: item.issale,
            cost_price: item.cost_price,
            temp_sales_price: parseFloat(item.sales_price).toFixed(2),
            ismorediscounts: item.ismorediscounts,
            morediscountslabel: item.morediscountslabel,
            morediscountsmoney: item.morediscountsmoney,
            morediscountsitemnum: item.morediscountsitemnum,
            issuperposition: item.issuperposition,
            morediscountdesc: item.morediscountdesc,
            morediscountsname: item.morediscountsname
          })
          // !that.initialSku.id &&
          if (item.skuid == that.listItem.skuid) {
            that.initialSku = {
              id: item.skuid,
              price: parseFloat(item.sales_price).toFixed(2),
              s1: item.spec_group_id.split('_')[0],
              s2: item.spec_group_id.split('_')[1],
              s3: item.spec_group_id.split('_')[2],
              selectedNum: parseInt(item.num),
              stock_num: stockNum,
              islimit: item.islimit,
              issale: item.issale,
              cost_price: item.cost_price,
              temp_sales_price: parseFloat(item.sales_price).toFixed(2),
              ismorediscounts: item.ismorediscounts,
              morediscountslabel: item.morediscountslabel,
              morediscountsmoney: item.morediscountsmoney,
              morediscountsitemnum: item.morediscountsitemnum,
              issuperposition: item.issuperposition,
              morediscountdesc: item.morediscountdesc,
              morediscountsname: item.morediscountsname
            }
          }
          // }
        })
        // console.log('sku.list', that.sku.list)
        // console.log('initialSku', that.initialSku)
        that.showsku = true
      }
    },
    checkedSku(skuValue) {
      if (!skuValue.selectedSkuComb) {
        this.sureGray = true
      } else {
        this.sureGray = false
      }
      var skuStr = ''
      this.skuname = ''
      var len = this.listItem.sku_rule_list
      var skuIndex = 0
      var index = 0
      Object.keys(skuValue.selectedSku).forEach(function(key) {
        skuIndex++
        if (skuValue.selectedSku[key] != '') {
          skuStr =
            skuStr == '' ? skuValue.selectedSku[key] : skuStr + '_' + skuValue.selectedSku[key]
          index++
        }
      })
      if (index == skuIndex) {
        for (var i = 0; i < len.length; i++) {
          if (len[i].spec_group_id == skuStr) {
            this.skuname = len[i].sku_name
            this.goods.picture = len[i].spec_imgpath
            if (skuValue.selectedSkuComb !== null) {
              this.skuprice = parseFloat(skuValue.selectedSkuComb.price).toFixed(2)
              this.skucostprice = parseFloat(skuValue.selectedSkuComb.cost_price).toFixed(2)
            }
            break
          }
        }
      } else {
        if (this.listItem.sales_low_price != this.listItem.sales_high_price) {
          this.skuprice =
            parseFloat(this.listItem.sales_low_price).toFixed(2) +
            '-' +
            parseFloat(this.listItem.sales_high_price).toFixed(2)
        } else {
          this.skuprice = parseFloat(this.listItem.sales_low_price).toFixed(2)
        }
        this.skucostprice = ''
      }
      // console.log(skuValue)
    },
    num: function(items) {
      var that = this
      setTimeout(function() {
        if (!that.goodsDelShow) {
          that.fullDiscountRuleFn()
          that.totalMoney()
          var datas = {
            skuid: items.skuid,
            num: items.num,
            new_skuid: ''
          }
          that.updateProduct(datas)
        }
      })
    },
    // sub: function (items, idx) {
    //   var that = this
    //   setTimeout(function () {
    //     if (!this.goodsDelShow) {
    //       that.totalMoney()
    //       var datas = {
    //         'skuid': items.skuid,
    //         'num': items.num,
    //         'new_skuid': ''
    //       }
    //       that.updateProduct(datas)
    //     }
    //   })
    // },
    overlimit: function(items) {
      // console.log(items.num, items.canbuycnt)
      if (items.num >= items.canbuycnt) {
        this.$toast('数量超出范围~')
      }
    },
    totalMoney: function() {
      var that = this
      that.totalmoney = 0
      that.oldtotalmoney = 0
      that.discounmoney = 0
      that.currentfullgiftmoney = 0
      that.currentdiscount = 0
      that.saletotalmoney = 0
      that.FlodMsg = ''
      that.FullGiftMsg = ''
      that.goodsnum = 0
      that.deposittotalmoney = 0
      that.directReductionmoney = 0
      that.morediscountsmoney = 0
      that.fullMinus_totalmoney = 0
      let money = 0,
        discountlist = [],
        discount_rule = {},
        fullMinus_totalmoney = 0
      that.isChooseProduct.forEach(function(item) {
        // morediscountsmoney
        if (!item.num) return
        let morediscountsmoney = 0
        if (item.ismorediscounts && item.num >= item.morediscountsitemnum) {
          if (item.issuperposition != 0) {
            morediscountsmoney =
              parseFloat(item.morediscountsmoney) * parseInt(item.num / item.morediscountsitemnum)
          } else {
            morediscountsmoney = parseFloat(item.morediscountsmoney)
          }
        }
        that.morediscountsmoney += morediscountsmoney
        that.totalmoney =
          that.totalmoney + parseFloat(item.sales_price) * parseInt(item.num) - morediscountsmoney
        if (item.isdeposit == 1) {
          that.deposittotalmoney += parseFloat(item.depositmoney)
          that.saletotalmoney +=
            (parseFloat(item.sales_price) + parseFloat(item.depositmoney)) * parseInt(item.num)
        } else {
          that.saletotalmoney += parseFloat(item.sales_price) * parseInt(item.num)
        }
        that.oldtotalmoney = that.oldtotalmoney + parseFloat(item.cost_price) * parseInt(item.num)
        if (item.isdiscount == 1 || item.isFullDiscount == 1) {
          that.goodsnum += parseInt(item.num)
          if (item.isdiscount == 1) money += parseFloat(item.sales_price) * parseInt(item.num)
        }
        if (item.fullMonusRules && item.fullMonusRules.isfullMinus == 1) {
          fullMinus_totalmoney += parseFloat(item.sales_price) * parseInt(item.num)
        }
        if (item.isDirectReduction && item.isDirectReduction == 1) {
          that.saletotalmoney += parseFloat(item.directReductionPrice) * item.num
          that.directReductionmoney += parseFloat(item.directReductionPrice) * item.num
        }
      })
      that.fullMinus_totalmoney = fullMinus_totalmoney
      that.saletotalmoney += that.fullDiscountmoney
      // 折上折
      if (that.discountrule && that.discountrule.discountenable == 1) {
        discount_rule = that.discountrule
        discountFn()
      } else if (that.fullDiscountRule && that.fullDiscountRule.discountenable == 1) {
        // 限时折扣
        discount_rule = {
          discountenable: that.fullDiscountRule.discountenable,
          discountlist: that.fullDiscountRule.rulelist
        }
        discount_rule.discountlist.map((item) => {
          item.itemnum = item.num
        })
        discountFn()
      }
      function discountFn() {
        discountlist = discount_rule.discountlist
        if (parseInt(that.goodsnum) == 0) {
          var discount = discountlist[0].discount
          var txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
          that.FlodMsg = '惊喜！选购活动商品最高可享受' + txt + '折'
          that.currentdiscount = 1
        } else if (parseInt(that.goodsnum) >= parseInt(discountlist[0].itemnum)) {
          let discount = discountlist[0].discount
          let txt = (discount * 100) % 10 == 0 ? (discount * 100) / 10 : discount * 100
          if (that.fullgiftrule.actstatus && parseInt(that.fullgiftrule.actstatus) == 1) {
            that.FlodMsg = ''
          } else {
            that.FlodMsg = '惊喜！已选' + that.goodsnum + '件享' + txt + '折'
          }
          that.currentdiscount = discount
        } else if (
          parseInt(that.goodsnum) < parseInt(discountlist[discountlist.length - 1].itemnum)
        ) {
          let discount1 = discountlist[discountlist.length - 1].discount
          let txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
          that.FlodMsg =
            '惊喜！已选' +
            that.goodsnum +
            '件，再加' +
            (parseInt(discountlist[discountlist.length - 1].itemnum) - that.goodsnum) +
            '件即可享受' +
            txt +
            '折。'
          that.currentdiscount = 1
        } else {
          try {
            discountlist.forEach(function(item, index) {
              if (parseInt(that.goodsnum) >= parseInt(item.itemnum)) {
                let discount1 = item.discount
                let discount2 = discountlist[index - 1].discount
                let txt = (discount1 * 100) % 10 == 0 ? (discount1 * 100) / 10 : discount1 * 100
                let txt1 = (discount2 * 100) % 10 == 0 ? (discount2 * 100) / 10 : discount2 * 100
                that.FlodMsg =
                  '惊喜！已选' +
                  that.goodsnum +
                  '件享' +
                  txt +
                  '折，再加' +
                  (parseInt(discountlist[index - 1].itemnum) - that.goodsnum) +
                  '件即可享受' +
                  txt1 +
                  '折。'
                that.currentdiscount = discount1
                throw new Error()
              }
            })
          } catch (e) {}
        }
      }

      // 满减
      if (that.fullMinusRules.actStatus == 1) {
        if (that.fullMinusRules.isSuperpose == 1 && fullMinus_totalmoney > 0) {
          let variable = Math.floor(
            fullMinus_totalmoney / parseFloat(that.fullMinusRules.fullMoney)
          )
          variable = variable + 1
          let m = parseFloat(
            parseFloat(that.fullMinusRules.fullMoney) * variable - fullMinus_totalmoney
          ).toFixed(2)
          let fullminusmoney_temp =
            fullMinus_totalmoney -
            parseFloat(that.fullMinusRules.fullMoney) * (variable > 1 ? variable - 1 : 1)
          if (fullminusmoney_temp > 0) {
            that.fullMinusMsg = `已减${(
              parseFloat(that.fullMinusRules.minusMoney) * (variable > 1 ? variable - 1 : 1)
            ).toFixed(2)}元，<span>还差${parseFloat(m).toFixed(2)}元</span>满${parseFloat(
              that.fullMinusRules.fullMoney
            ) * variable}减${parseFloat(that.fullMinusRules.minusMoney) * variable}`
          } else {
            that.fullMinusMsg = `已选${parseFloat(fullMinus_totalmoney).toFixed(
              2
            )}元，<span>还差${parseFloat(m).toFixed(2)}元</span>满${parseFloat(
              that.fullMinusRules.fullMoney
            ) * variable}减${parseFloat(that.fullMinusRules.minusMoney) * variable}`
          }
          that.fullminusmoney = parseFloat(that.fullMinusRules.minusMoney) * (variable - 1)
        } else if (fullMinus_totalmoney > 0) {
          if (fullMinus_totalmoney < that.fullMinusRules.fullMoney) {
            let m = parseFloat(
              parseFloat(that.fullMinusRules.fullMoney) - fullMinus_totalmoney
            ).toFixed(2)
            that.fullMinusMsg = `已选${parseFloat(fullMinus_totalmoney).toFixed(
              2
            )}元，<span>还差${parseFloat(m).toFixed(2)}元</span>满${parseFloat(
              that.fullMinusRules.fullMoney
            )}减${parseFloat(that.fullMinusRules.minusMoney)}`
            that.fullminusmoney = 0
          } else {
            that.fullMinusMsg = `已选${parseFloat(fullMinus_totalmoney).toFixed(
              2
            )}元，满${parseFloat(that.fullMinusRules.fullMoney)}减${parseFloat(
              that.fullMinusRules.minusMoney
            )}<span>可减${parseFloat(that.fullMinusRules.minusMoney).toFixed(2)}元</span>`
            that.fullminusmoney = parseFloat(that.fullMinusRules.minusMoney)
          }
        } else {
          that.fullMinusMsg = `活动进行中，${that.fullMinusRules.actLabel}`
          that.fullminusmoney = 0
        }
        that.totalmoney = that.totalmoney - that.fullminusmoney
      }

      // 满赠
      if (this.fullgiftrule && parseInt(this.fullgiftrule.actstatus) == 1 && !this.FlodMsg) {
        if (this.fullgiftrule.rulelist && this.fullgiftrule.rulelist.length > 0) {
          var rulelist = this.fullgiftrule.rulelist
          var price = 0
          that.isChooseProduct.forEach(function(item) {
            let morediscountsmoney = 0
            if (item.isfullgift == 1) {
              if (item.ismorediscounts && item.num >= item.morediscountsitemnum) {
                if (item.issuperposition != 0) {
                  morediscountsmoney =
                    parseFloat(item.morediscountsmoney) *
                    parseInt(item.num / item.morediscountsitemnum)
                } else {
                  morediscountsmoney = parseFloat(item.morediscountsmoney)
                }
              }
              if (parseInt(item.isdiscount) == 1 && that.currentdiscount > 0) {
                price +=
                  Number(item.sales_price) * parseInt(item.num) * Number(that.currentdiscount) -
                  morediscountsmoney
              } else {
                price += Number(item.sales_price) * parseInt(item.num) - morediscountsmoney
              }
            }
          })
          that.currentfullgiftmoney = parseFloat(price - that.fullminusmoney).toFixed(2)
          // console.log('currentfullgiftmoney', that.currentfullgiftmoney)
          if (!isNaN(Number(that.currentfullgiftmoney))) {
            if (
              parseFloat(that.currentfullgiftmoney) == 0 ||
              parseFloat(that.currentfullgiftmoney) <
                parseFloat(rulelist[rulelist.length - 1].allmoney)
            ) {
              let m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
                ? parseFloat(
                    Number(rulelist[rulelist.length - 1].allmoney) -
                      Number(that.currentfullgiftmoney)
                  ).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[rulelist.length - 1].senditemprice))
                ? parseFloat(rulelist[rulelist.length - 1].senditemprice).toFixed(2)
                : '0.00'
              that.FullGiftMsg =
                '惊喜！还差<span>' +
                m +
                '</span>元，即送价值<span>' +
                (parseFloat(m1) > 0
                  ? m1
                  : parseFloat(rulelist[rulelist.length - 1].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[rulelist.length - 1].senditemname
            } else if (parseFloat(that.currentfullgiftmoney) >= parseFloat(rulelist[0].allmoney)) {
              let m = !isNaN(parseFloat(rulelist[0].allmoney))
                ? parseFloat(rulelist[0].allmoney).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
                ? parseFloat(rulelist[0].senditemprice).toFixed(2)
                : '0.00'
              that.FullGiftMsg =
                '惊喜！已满<span>' +
                m +
                '</span>元，送价值<span>' +
                (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[0].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[0].senditemname
            } else {
              try {
                rulelist.forEach(function(item, index) {
                  if (parseFloat(that.currentfullgiftmoney) >= parseFloat(item.allmoney)) {
                    let m = !isNaN(parseFloat(rulelist[index].allmoney))
                      ? parseFloat(Number(rulelist[index].allmoney)).toFixed(2)
                      : '0.00'
                    let m1 = !isNaN(parseFloat(rulelist[index].senditemprice))
                      ? parseFloat(rulelist[index].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg =
                      '惊喜！已满<span>' +
                      m +
                      '</span>元，送价值<span>' +
                      (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[index].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index].senditemname
                    let m2 = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                      ? parseFloat(
                          Number(rulelist[index - 1].allmoney) - Number(that.currentfullgiftmoney)
                        ).toFixed(2)
                      : '0.00'
                    let m3 = !isNaN(parseFloat(rulelist[index - 1].senditemprice))
                      ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg +=
                      '，再加<span>' +
                      m2 +
                      '</span>元，奖品升级为价值<span>' +
                      (parseFloat(m3) > 0
                        ? m3
                        : parseFloat(rulelist[index - 1].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index - 1].senditemname
                    throw new Error()
                  }
                })
              } catch (e) {}
            }
            // console.log('FullGiftMsg', that.FullGiftMsg)
          }
        }
        if (that.FullGiftMsg != '') that.FullGiftMsg += '（' + this.fullgiftrule.actname + '）'
      }

      if (money > 0 && that.currentdiscount > 0) {
        that.discounmoney = money * (1 - that.currentdiscount)
        that.totalmoney -= that.discounmoney
      }
    },
    productFn: function(items) {
      this.$clickburiedPoint({
        url: 'ckysdatacenter/itemclick/save',
        data: {
          itemid: items.itemid,
          scenepoint: 'ITEMCART'
        }
      })
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid,
          live_id: items.live_id
        }
      })
    },
    // 客服
    keFu: function() {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          kefu()
        }
      } else {
        kefu()
      }
    },
    goflod: function(type) {
      window.location = '/static/wx/html/20190820/Flod/flodlist.html?acttype=' + type
    },
    gofullgift: function() {
      var url =
        '/static/wx/html/fullGift/index.html?currentfullgiftmoney=' +
        this.currentfullgiftmoney +
        '&currentdiscount=' +
        this.currentdiscount
      var skuids = [],
        nums = []
      this.isChooseProduct.map((item) => {
        skuids.push(item.skuid)
        nums.push(item.num)
      })
      url += '&skuids=' + skuids.join() + '&nums=' + nums.join()
      window.location = url
    },
    gofullsubtract: function() {
      window.location.href = '/static/wx/html/20190820/Flod/fullsubtract.html?acttype=fullsubtract'
    },
    showActDesc: function(obj) {
      var that = this
      that.msglist = []
      if (
        that.discountrule &&
        that.discountrule.discountenable == 1 &&
        that.discountrule.discountlist &&
        obj.isdiscount == 1
      ) {
        var msg = []
        that.discountrule.discountlist.forEach(function(item, index) {
          var txt =
            (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
          msg.push(item.itemnum + '件' + txt + '折')
        })
        var discountruledesc = '满' + msg.join(',')
        that.msglist.push({
          enable: that.discountrule.discountenable,
          shortdesc: discountruledesc,
          desc: that.discountrule.discountdescription,
          name: that.discountrule.name,
          actlabel: that.discountrule.actlabel,
          statusmsg: '参与活动商品享受折上折优惠'
        })
      }
      if (
        that.fullgiftrule &&
        that.fullgiftrule.actstatus == 1 &&
        that.fullgiftrule.rulelist &&
        obj.isfullgift == 1
      ) {
        that.msglist.push({
          enable: that.fullgiftrule.actstatus,
          shortdesc: that.fullgiftrule.actdesc,
          desc: that.fullgiftrule.actdesc,
          name: that.fullgiftrule.actname,
          actlabel: that.fullgiftrule.actlabel
        })
      }
      if (that.halfprice.halfpricestatus == 1 && obj.ishalf == 1) {
        that.msglist.push({
          enable: that.halfprice.halfpricestatus,
          shortdesc: that.halfprice.halfpricedesc,
          desc: that.halfprice.halfpricedesc,
          name: that.halfprice.halfactname,
          actlabel: that.halfprice.halfactlabel
        })
      }
      if (that.presalerule.actstatus == 1) {
        that.msglist.push({
          enable: that.presalerule.actstatus,
          shortdesc: that.presalerule.actdesc,
          desc: that.presalerule.actdesc,
          name: that.presalerule.actname,
          actlabel: '定金翻倍'
        })
      }
      if (that.fullDiscountRule.discountenable == 1) {
        that.msglist.push({
          enable: that.fullDiscountRule.discountenable,
          shortdesc: that.fullDiscountRule.actdesc,
          desc: that.fullDiscountRule.actdesc,
          name: that.fullDiscountRule.actlabel,
          actlabel: that.fullDiscountRule.actlabel
        })
      }
      if (obj.ismorediscounts == 1) {
        that.msglist.push({
          enable: obj.ismorediscounts,
          shortdesc: obj.morediscountdesc,
          desc: obj.morediscountdesc,
          name: obj.morediscountsname,
          actlabel: obj.morediscountslabel
        })
      }
      that.showaction = true
    },
    dateFn: function(date, type) {
      if (!date) return
      var arr = date.split(' ')
      var arrDateTime = arr[1].split(':')
      var arrDate = arr[0].split('-')
      if (type == 'datetime') {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日 ' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1] +
          '</span>'
        )
      } else if (type == 'datetimestr') {
        // return parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日' + arrDateTime[0] + ':' + arrDateTime[1]
        return (
          parseInt(arrDate[1]) +
          '月' +
          parseInt(arrDate[2]) +
          '日' +
          arrDateTime[0] +
          ':' +
          arrDateTime[1]
        )
      } else if (type == 'datestr') {
        return (
          parseInt(arrDate[0]) + '年' + parseInt(arrDate[1]) + '月' + parseInt(arrDate[2]) + '日'
        )
      } else {
        return (
          '<span><i>' +
          parseInt(arrDate[0]) +
          '</i> 年 <i>' +
          parseInt(arrDate[1]) +
          '</i> 月 <i>' +
          parseInt(arrDate[2]) +
          '</i> 日</span>'
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #eeeeee;
  padding-bottom: 0.58rem;
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -moz-flex-direction: column;
  -o-flex-direction: column;
  /*overflow: hidden;*/
  height: 100%;
  flex: 0;
  -webkit-flex: 0;
  -moz-flex: 0;
  -ms-flex: 0;
  -o-flex: 0;
  .my_scroller {
    /*padding-top: 0.4rem;*/
  }
  .header {
    height: 0.38rem;
    line-height: 0.38rem;
    background: #fff;
    padding: 0 0.11rem;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
    .tit {
      color: #3f3f3f;
      font-size: 0.13rem;
      float: left;
    }
    .kefu {
      float: right;
      img {
        margin-top: 0.09rem;
        width: 0.2rem;
        height: 0.2rem;
      }
    }
    .edit {
      float: right;
      font-size: 0.13rem;
      color: #191818;
      margin-left: 0.15rem;
    }
    .edit.active {
      color: #fc0324;
    }
  }
  #cup {
    flex: 1;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    -o-flex: 1;
    /*margin-bottom: 1.5rem;*/
    /*overflow-y: auto;*/
    .couponmsg {
      background: #fff1f4;
      height: 0.6rem;
      padding: 0.1rem 0.15rem;
      line-height: 0.18rem;
      margin: 0.05rem 0 0.1rem;
      .couponImg {
        position: relative;
        margin-right: 0.08rem;
        img {
          width: 0.4rem;
          height: 0.4rem;
        }
        span {
          position: absolute;
          left: 50%;
          top: 52%;
          transform: translate(-50%, -50%);
          line-height: 0.18rem;
          font-weight: bold;
        }
      }
    }
  }
  .cart_list {
    padding: 0 0.11rem;
    .fullsubtract {
      z-index: 1;
      position: relative;
      left: 0;
      bottom: 0;
      padding: 0.15rem 0.15rem 0;
      margin-bottom: -0.13rem;
      margin-top: 0.1rem;
      border-radius: 0.03rem;
      &:after {
        content: '';
        display: block;
        height: 0.01rem;
        background: #d8d8d8;
        position: absolute;
        left: 0.15rem;
        right: 0.15rem;
        bottom: 0;
      }
      .msg {
        .txt {
          display: flex;
          align-items: flex-start;
          b {
            font-weight: 400;
            margin-left: 0.06rem;
          }
        }
      }
    }
    .product_list {
      display: flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      /*justify-content: center;*/
      /*-o-justify-content: center;*/
      /*-moz-justify-content: center;*/
      /*-ms-justify-content: center;*/
      /*-webkit-justify-content: center;*/
      align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -webkit-align-items: center;
    }
    .proitem {
      display: flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      align-items: flex-start;
      -o-align-items: flex-start;
      -moz-align-items: flex-start;
      -ms-align-items: flex-start;
      -webkit-align-items: flex-start;
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
    }
    .cart_item {
      margin-top: 0.1rem;
      background: #fff;
      padding: 0.15rem 0.11rem;
      border-radius: 0.03rem;
      position: relative;
      &:first-of-type {
        margin-top: 0.05rem;
      }
      .proimgx {
        position: relative;
        margin-right: 0.07rem;
        margin-left: 0.07rem;
        .proimg {
          width: 0.8rem;
          height: 0.8rem;
          margin: 0 auto;
        }
        .soldout {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0.54rem;
          height: 0.54rem;
          margin-top: -0.27rem;
          margin-left: -0.27rem;
        }
      }

      .goods_info {
        position: relative;
        flex: 1;
        -webkit-flex: 1;
        -o-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        min-height: 0.8rem;
        .goods_tit {
          font-size: 0.13rem;
          color: #292929;
          overflow: hidden;
          margin-top: 0.04rem;
          &.flex {
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            justify-content: space-between;
            -webkit-justify-content: space-between;
            -moz-justify-content: space-between;
            -ms-justify-content: space-between;
            -o-justify-content: space-between;
            > label {
              overflow: initial;
              margin-left: 0.1rem;
              color: #6c6c6c;
              font-size: 0.1rem;
            }
          }
          label {
            /*max-width: 1.9rem;*/
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            display: inline-block;
          }
          img {
            display: inline-block;
            width: 0.15rem;
            height: 0.15rem;
            vertical-align: baseline;
            margin-left: 0.03rem;
          }
        }
        .goods_spec {
          font-size: 0.12rem;
          color: #6c6c6c;
          line-height: 0.16rem;
          margin-top: 0.05rem;
          overflow: hidden;
          display: flex;
          align-items: center;
          .dspec {
            float: left;
            background-color: #f6f6f6;
            padding: 0.01rem 0.07rem;
            border-radius: 0.1rem;
            font-size: 0.11rem;
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            justify-content: center;
            -webkit-justify-content: center;
            -moz-justify-content: center;
            -ms-justify-content: center;
            -o-justify-content: center;
            .van-icon-arrow-down {
              vertical-align: middle;
            }
            &.again {
              background-color: transparent;
              border: 0.01rem solid #fe5e00;
              color: #fe5e00;
            }
          }
          .stock {
            float: left;
            height: 0.12rem;
            margin-left: 0.03rem;
            img {
              height: 100%;
            }
          }
        }
        .PriceAndNum {
          min-height: 0.22rem;
          margin-top: 0.1rem;
          display: flex;
        }
        .tag {
          margin-top: 0.04rem;
        }
        .goods_price {
          flex: 1;
          font-size: 0.14rem;
          line-height: 0.2rem;
          color: #fc0324;
          display: flex;
          align-items: center;
          float: left;
          .smallprice {
            display: flex;
            align-items: flex-end;
            line-height: 0.13rem;
            &.grayPrice {
              color: #6c6c6c;
              margin-bottom: 0.08rem;
            }
            b {
              font-size: 0.14rem;
              /*line-height: .2rem;*/
              font-weight: 600;
            }
          }
          sub {
            font-weight: normal;
            font-size: 0.12rem;
            line-height: 0.12rem;
            vertical-align: baseline;
          }
          sup {
            font-size: 0.11rem;
            line-height: 0.11rem;
            vertical-align: baseline;
            font-weight: 500;
          }
        }
        .goods_stepper {
          float: right;
        }
      }
      .act_desc_tag {
        font-size: 0.12rem;
        margin-top: 0.08rem;
        margin-left: 1.13rem;
        .van-icon-arrow {
          float: right;
        }
      }
      .act_desc_time {
        font-size: 0.11rem;
        margin-left: 0.25rem;
        color: #f12a0e;
        margin-top: 0.04rem;
        display: flex;
        align-items: center;
        img {
          width: 0.12rem;
        }
        .txt {
          font-size: 0.12rem;
          color: #f12a0e;
          transform: scale(0.92, 0.92);
          margin-left: -0.03rem;
          line-height: 0.17rem;
        }
      }
      .act_desc_time .van-icon-warning-o {
        float: left;
        font-size: 0.16rem;
        display: block;
        margin-right: 0.04rem;
      }
      .act_desc {
        font-size: 0.12rem;
        transform: scale(0.8);
        margin-top: 0.04rem;
        color: #fc0324;
      }
    }
    .cart_item.soldoutx {
      /*opacity: 0.56;*/
      .dspec {
        color: #b5b5b5;
      }
      .goods_tit {
        color: #878787;
      }
      .smallprice {
        color: #fe7285;
      }
    }
  }
  .nodata {
    background: #fff;
    padding-top: 0.4rem;
    padding-bottom: 0.19rem;
    img {
      width: 0.88rem;
      height: 0.88rem;
      margin: 0 auto;
    }
    .msg {
      font-size: 0.14rem;
      line-height: 0.2rem;
      margin-top: 0.14rem;
      color: #292929;
      text-align: center;
    }
    .gobtn {
      margin: 0 auto;
      margin-top: 0.16rem;
      width: 1.09rem;
      height: 0.36rem;
      border: solid 1px #fc0324;
      border-radius: 0.2rem;
      font-size: 0.14rem;
      line-height: 0.34rem;
      text-align: center;
      color: #fc0324;
    }
  }
  .pro_related_goods {
    border-top: solid 0.1rem #eeeeee;
    background: #fff;
    .pro_related_goods_tit {
      width: 50%;
      margin: 0 auto;
    }
    .pro_related_list {
      padding: 0 0.11rem;
      background: #fff;
      overflow: hidden;
      .pro_item:nth-child(2n) {
        padding-left: 0.035rem;
      }
      .pro_item:nth-child(2n-1) {
        padding-right: 0.035rem;
      }
    }
  }
  .pro_submit {
    position: fixed;
    bottom: 0.44rem;
    left: 0;
    width: 100%;
    font-size: 0.12rem;
    z-index: 2001;
    background: rgba(255, 255, 255, 1);
  }
  .pro_tools:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    transform: translateY(-50%);
    background: #bebebe;
    content: '';
  }
  .pro_tools {
    position: relative;
    height: 0.52rem;
    padding: 0 0.15rem;
    /*box-shadow: 0 0.01rem 0 0 rgba(0, 0, 0, 0.25);*/
    /*border-top: 0.005rem solid #BEBEBE;*/
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    justify-content: space-around;
    -webkit-justify-content: space-around;
    -moz-justify-content: space-around;
    -ms-justify-content: space-around;
    -o-justify-content: space-around;
    .van-checkbox {
      float: left;
      font-size: 0.12rem;
      /*margin-top: 0.025rem;*/
    }
    .pro_total_details {
      float: left;
      font-size: 0.12rem;
      /*margin-top: .07rem;*/
      margin-left: 0.15rem;
      width: 50%;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      align-items: flex-end;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      /*height: 0.2rem;*/
      .offerdetails {
        margin-left: 0.01rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .flp {
          font-size: 0.11rem;
          color: #fc0324;
          margin-left: 0.01rem;
          transform: scale(0.9, 0.9);
          float: left;
        }
        img {
          float: left;
          width: 0.11rem;
          vertical-align: middle;
        }
      }
      .total {
        .totalname {
          font-size: 0.13rem;
          /*line-height: .235rem;*/
          color: #252525;
          float: left;
        }
        .totalprice {
          float: left;
          padding-left: 0.05rem;
        }
        .ppo {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
        .oldprice {
          font-size: 0.11rem;
          color: #888888;
          text-decoration: line-through;
        }
        .smallprice {
          color: #fc0324;
          font-size: 0.15rem;
          /*line-height: .215rem;*/
          font-weight: bold;
        }
        sub {
          font-weight: normal;
          font-size: 0.11rem;
          vertical-align: baseline;
        }
      }
    }
    .settlement {
      background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%);
      font-size: 0.13rem;
      border-radius: 0.19rem;
      color: #fff;
      text-align: center;
      float: right;
      /*padding: 0.05rem 0.09rem;*/
      line-height: 0.32rem;
      height: 0.32rem;
      width: 0.85rem;
      /*margin-top: .05rem;*/
    }
    .settlement.disabled {
      background: #dddddd;
      color: #fff;
    }
    .del {
      font-size: 0.12rem;
      border-radius: 0.14rem;
      color: #fc0324;
      text-align: center;
      float: right;
      padding: 0.05rem 0.09rem;
      /*margin-top: .09rem;*/
      border: solid 1px #fc0324;
      margin-left: 0.1rem;
      min-width: 0.7rem;
    }
    .coll {
      font-size: 0.12rem;
      border-radius: 0.14rem;
      color: #262626;
      text-align: center;
      float: right;
      padding: 0.05rem 0.09rem;
      /*margin-top: .09rem;*/
      border: solid 1px #606060;
    }
    .choosetxt {
      font-size: 0.12rem;
      /*margin-top: .14rem;*/
      line-height: 0.2rem;
      float: left;
      margin-left: 0.2rem;
      color: #222222;
    }
  }
  .sureGray {
    opacity: 0.38;
  }
  .sure {
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
  }
  /*.offer.van-popup--bottom{*/
  /*bottom: .978rem;*/
  /*}*/
  .offerdetailsdis {
    .ofd1 {
      font-size: 0.12rem;
      color: #3d3d3d;
      text-align: center;
      line-height: 0.17rem;
      margin-top: 0.18rem;
      margin-bottom: 0.2rem;
    }
    .list {
      padding: 0.15rem 0.15rem 1rem;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.14rem;
        padding-bottom: 0.12rem;
        color: #242424;
        line-height: 0.2rem;
        font-weight: 400;
      }
      .goodstotalprice {
        color: #242424;
        font-weight: 600;
      }
      .combined {
        font-size: 0.16rem;
        color: #fc0324;
        line-height: 0.22rem;
        font-weight: 400;
      }
      .desc {
        color: #3d3d3d;
        font-size: 0.12rem;
        line-height: 0.17rem;
        padding-bottom: 0.3rem;
      }
    }
  }
  .van-action-sheet__close {
    background: url('../../assets/images/closex.png') center no-repeat;
    background-size: 0.2rem 0.2rem;
  }
  .van-action_model {
    height: 70vh;
    .van-item {
      padding: 0.14rem;
      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }
      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }
    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      .vanbtn {
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
        border-radius: 0.25rem;
      }
    }
  }
  .presale_info_dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3001;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .dialog {
      width: 79%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.04rem;
      height: 2.24rem;
      position: relative;
      .header1 {
        width: 70%;
        margin: 0 auto;
        font-weight: bold;
        .van-divider {
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          margin: 0.2rem 0;
          line-height: 0.24rem;
          border-color: #666666;
          border-style: solid;
          border-width: 0;
          color: #333333;
          font-size: 0.21rem;
        }
        .van-divider::before,
        .van-divider::after {
          content: ' ';
          display: block;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          flex: 1;
          box-sizing: border-box;
          height: 1px;
          border-color: inherit;
          border-style: inherit;
          border-width: 0 0 0;
          margin-right: 0.16rem;
          margin-left: 0.16rem;
        }
      }
      .content {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        color: #444444;
        font-size: 0.14rem;
        margin-top: 0.02rem;
        line-height: 0.2rem;
        height: 1.2rem;
        overflow-y: auto;
      }
      .btn {
        background: #fc0324;
        width: 50%;
        text-align: center;
        color: #fff;
        font-size: 0.15rem;
        border-radius: 0.16rem;
        height: 0.31rem;
        line-height: 0.31rem;
        position: absolute;
        left: 25%;
        bottom: 0.22rem;
      }
    }
  }
}
</style>
<style lang="scss">
.shop {
  .good_sku {
    .van-icon-cross {
      background: url('../../assets/images/close3.png') no-repeat center;
      background-size: 100%;
      color: transparent;
    }
  }
}

.van-checkbox__icon {
  height: auto !important;
}
.van-checkbox {
  .van-checkbox__label {
    line-height: 0.2rem;
  }
}
.container.shop {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku__costprice-symbol {
    margin-left: 0.05rem;
  }
  .good_sku .van-sku__costprice-symbol,
  .van-sku__costprice-num {
    font-size: 0.12rem;
    color: #979797;
    font-weight: normal;
    line-height: 0.2rem;
    text-decoration: line-through;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
    font-size: 0.11rem;
  }
  .PriceAndNum .van-stepper__input {
    width: 0.35rem;
  }
  /*.good_sku .van-stepper__minus::before, .van-stepper__plus::before{*/
  /*width: 0.09rem;*/
  /*border-radius: 0.03rem;*/
  /*}*/
  /*.good_sku .van-stepper__minus::after, .van-stepper__plus::after{*/
  /*height: 0.09rem;*/
  /*border-radius: 0.03rem !important;*/
  /*}*/
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
  .pro_details_con {
    font-size: 0.14rem;
  }
  .pro_details_con img {
    width: 100% !important;
    height: auto !important;
  }
  .pro_details_con .ckeditor-html5-video {
    width: 100%;
  }
  .pro_details_con .ckeditor-html5-video video {
    width: 100%;
  }
  .van-sku-stepper-stock {
    display: none;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopcart/cart.vue